function Foot() {
  return (
    <foot className="bg-warning footer pt-2 pd-2 d-flex align-items-center justify-content-center">
      <p> Copyright &copy; | All Rights Reserved - Country Farm 2021</p>
    </foot>
  );
}

export default Foot;
